import { IObservable, Subject } from '~/rage/utils';
import { RockPaperScissorsChoice, RockPaperScissorsGameStatus } from '~/shared';
import { RpcService } from '../RpcService';
import { VarsService } from '../VarsService';
import { IRockPaperScissorsService } from './rockPaperScissorsTypes';

export class RockPaperScissorsService implements IRockPaperScissorsService {
	private status = new Subject<RockPaperScissorsGameStatus>(
		RockPaperScissorsGameStatus.WAITING,
	);
	private opponentName = new Subject<string>('');
	private opponentChoice = new Subject<RockPaperScissorsChoice | null>(null);
	private timer = new Subject<number>(10_000);

	constructor(
		private readonly rpc: RpcService,
		private readonly vars: VarsService,
	) {
		this.vars
			.get('rockPaperScissors:status', RockPaperScissorsGameStatus.WAITING)
			.subscribe((status: RockPaperScissorsGameStatus) => {
				this.status.next(status);
			});

		this.vars
			.get('rockPaperScissors:opponentName', '')
			.subscribe((opponentName: string) => {
				this.opponentName.next(opponentName);
			});

		this.vars
			.get('rockPaperScissors:opponentChoice', null)
			.subscribe((opponentChoice: RockPaperScissorsChoice | null) => {
				this.opponentChoice.next(opponentChoice);
			});
	}

	public getStatus(): IObservable<RockPaperScissorsGameStatus> {
		return this.status;
	}

	public getTimer(): IObservable<number> {
		return this.timer;
	}

	public getOpponentName(): IObservable<string> {
		return this.opponentName;
	}

	public getOpponentChoice(): IObservable<RockPaperScissorsChoice | null> {
		return this.opponentChoice;
	}

	public async makeChoice(choice: RockPaperScissorsChoice): Promise<void> {
		return await this.rpc.invokeServer('rockPaperScissors:makeChoice', {
			choice,
		});
	}

	public async cancelOffer(): Promise<void> {
		return await this.rpc.invokeServer('rockPaperScissors:cancelOffer');
	}

	public async exit(): Promise<void> {
		return await this.rpc.invokeClient('rockPaperScissors:exit');
	}
}
